<GlobalNav backPath="{'/home'}" />
<div class="section">
  <div class="container">
    <div class="mt-5 mb-5">
      <Heading />
    </div>
  </div>

  <div class="container">
    {#if allExamsFinished}
      <div
        class="notification is-success has-text-centered mb-4 column is-three-fifths-desktop is-offset-one-fifth-desktop"
      >
        <p>
          Du hast alle Prüfungen erfolgreich beendet. Setze dich mit deinem
          <br class="show-on-desktop" />Trainer oder Golfclub in Verbindung um
          mit der Platzreife fortzufahren.
        </p>
      </div>
    {:else}
      <p class="mb-4 has-text-centered">
        Lerne hier deine Lektionen für die Platzreife. Am Ende jeder Lektion
        folgt die Prüfung.
        <br class="show-on-desktop" />Du kannst Lektionen wie Prüfungen in
        beliebiger Reihenfolge fertigstellen.
      </p>
    {/if}
    <h2 class="is-size-3 mb-5 has-text-centered">Lektionen</h2>

    {#if !userApproved && chaptersData && chapterStatii[chaptersData[1].slug] == 'ready'}
      <div class="notification is-warning has-text-left">
        <p>
          Die nächste Lektion kannst du beginnen, sobald du vom Golfclub
          freigeschalten wurdest. Gerne kannst du uns dazu auch anrufen, um den
          Vorgang zu beschleunigen.
        </p>
      </div>
    {/if}

    <nav class="columns is-multiline nav-chapters">
      {#if chaptersData}
        {#each chaptersData as ch}
          <!-- eslint-disable-next-line svelte(a11y-missing-attribute) -->
          <div
            on:click="{setChapter(ch)}"
            class="column is-one-third-desktop is-4-tablet is-narrow-tablet has-text-centered {isApprovedOrFirst(ch.slug) && chapterStatii[ch.slug] ? 'is-clickable chapter-' + chapterStatii[ch.slug] : ''}"
          >
            <div
              class="{chapterStatii[ch.slug] ? 'has-text-dark' : 'has-text-grey'}"
            >
              <img class="chapter-image-container" src="{ch.teaserImage}" />
              <p class="is-size-4 mt-4">
                {@html ch.title}
              </p>
            </div>
          </div>
        {/each}
      {:else}
        <div class="column">
          <div class="is-flex is-justify-content-space-around mt-5 mt-6">
            <Icon
              icon="spinner fa-pulse"
              type="debug"
              size="large"
              iconSize="fa-3x"
            />
          </div>
        </div>
      {/if}
    </nav>
  </div>
</div>

<script>
import {
  chapters,
  currentChapter,
  chapterNav,
  userIsApproved,
  userProgress,
  examProgress,
} from "./stores";
import { push } from "svelte-spa-router";
import { onMount } from "svelte";
import GlobalNav from "./GlobalNav.svelte";
import { chaptersSvc, progressSvc } from "./services";
import Heading from "./Heading.svelte";
import Icon from "./Icon.svelte";

export let params = {};

let chaptersData, chapterNavItems, userApproved, allExamsFinished;

// object with chapter slug + status
$: chapterStatii = chaptersData
  ? chaptersData.reduce((acc, ch) => {
      acc[ch.slug] = chaptersSvc.getChapterStatus(ch.slug);
      return acc;
    }, {})
  : {};

onMount(() => {
  chapters.subscribe((value) => {
    chaptersData = value;
  });
  chapterNav.subscribe((value) => {
    chapterNavItems = value;
    // triggers a re-evaluation
    chaptersData = chaptersData;
  });
  userProgress.subscribe((_) => {
    // triggers a re-evaluation
    chaptersData = chaptersData;
  });
  userIsApproved.subscribe((bool) => {
    userApproved = bool;
  });
  examProgress.subscribe(
    (_) => (allExamsFinished = progressSvc.allExamsFinished())
  );
});

const isApprovedOrFirst = (slug) => {
  return slug == "abschlag" || userApproved;
};

const setChapter = (ch) => {
  if (!chaptersSvc.getChapterStatus(ch.slug)) {
    return;
  }
  currentChapter.set(ch);

  const activeNavItem = chapterNavItems.find((n) => n.isActive());
  let slug = activeNavItem?.slug;
  if (!slug) {
    slug = "beantwortet";
  }

  push("/platzreife/" + ch.slug + "/" + slug);
};

window.finishAll = () => {
  /*
  "answerIndexes": [
    1,
    2,
    4
  ],
  "status": true,
  "fixated": true
  */

  const buildRulesRead = (len) => {
    const rules = {};
    for (let i = 0; i < len; i++) {
      rules[i] = true;
    }
    return rules;
  };

  const finishAllChapters = () => {
    const newUP = {
      closedPopups: {
        page_login: true,
        page_manager: true,
        page_intro: true,
        page_home: true,
        page_platzreife: true,
      },
    };
    newUP.chapters = {};
    chaptersData.forEach((ch) => {
      newUP.chapters[ch.slug] = {
        status: "success",
        videoPlayed: true,
        rulesRead: buildRulesRead(ch.rules.length),
      };
    });
    // this.q[qIndex].answerIndexes = answerIndexes;
    //   this.q[qIndex].status = equals(answerIndexes, correctAnswers);
    //   this.q[qIndex].fixated = true;
    progressSvc.setUserProgress(newUP);
  };
  finishAllChapters();
};
</script>

<style type="text/scss">
@import "./scss/colors";
@import "./scss/shared";
.nav-chapters {
  .column {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    border-bottom: 10px solid transparent;
  }
  .active {
    border-bottom: 10px solid #555555;
  }
  .is-clickable .chapter-image-container {
    filter: none;
    opacity: 1;
  }
  .is-clickable .chapter-image-container:hover {
    box-shadow: 0 0 10px #888888;
  }
  .chapter-image-container {
    filter: grayscale(1);
    width: 90%;
    margin: 0 auto;
    border-radius: 20px;
    border: 2px solid $color-light-grey;
    transition: all 0.3s ease;
    @media screen and (max-width: 1024px) {
      width: 80%;
    }
  }
  .chapter-ready .chapter-image-container {
    border-color: $color-dark-grey;
  }
  .chapter-started .chapter-image-container,
  .chapter-finished .chapter-image-container {
    border-color: $color-warning;
  }
  .chapter-success .chapter-image-container {
    border-color: $color-success;
  }
  .chapter-failed .chapter-image-container {
    border-color: $color-danger;
  }
}
.image-container {
  position: relative;
}
.chapter-started .circle {
  border-color: $color-warning;
}
.chapter-success .circle {
  border-color: $color-success;
}
.chapter-failed .circle {
  border-color: $color-danger;
}
@media only screen and (max-width: 576px) {
  .nav-chapters .column {
    margin-bottom: 30px;
  }
  // .tags {
  //   margin-bottom: 0;
  // }
}
</style>
